import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type MessageSize = Record<string, Record<string, number>>;

const initialState: { sizes: MessageSize } = {
  sizes: {}
}

interface UpdateSizeProp {
  jid: string
  size: [string, number][]
}

const messagesSize = createSlice({
  name: 'messagesSize',
  initialState,
  reducers: {
    updateSize: (state, { payload }: PayloadAction<UpdateSizeProp | UpdateSizeProp[]>) => {
      const chats = Array.isArray(payload) ? payload : [payload]
      chats.forEach((chat) => {
        const { jid, size } = chat
        size.forEach(([id, value]) => {
          if (!state.sizes[jid]) {
            state.sizes[jid] = {}
          }
          state.sizes[jid][id] = value
        })
      })
    }
  }
})

export const { updateSize } = messagesSize.actions
export default messagesSize.reducer
